<template>
    <div ref="container">
      <a-modal
        :title="title"
        :width="1600"
        :visible="visible"
        :getContainer="() => $refs.container"
        :maskStyle="{'top':'93px','left':'154px'}"
        :wrapClassName="wrapClassNameInfo()"
        :mask="isDesktop()"
        :maskClosable="false"
        @cancel="handleCancel"
        cancelText="关闭"
        style="top:50px;height: 90%;">
        <template slot="footer">
          <a-button @click="handleCancel">关闭</a-button>
          <a-button @click="handleOk">确定</a-button>
        </template>
        <!-- 产品信息 -->
        <!-- table区域-begin -->
        <Labeltemplate @selection-change="handleSelectionChange"></Labeltemplate>
        <!-- table区域-end -->
      </a-modal>
    </div>
  </template>
  
  <script>
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import {mixinDevice} from '@/utils/mixin'
    import { queryPiByPage, bindPrintTemplate } from '@/api/api'
    import Labeltemplate from '../Labeltemplate'
    import Vue from 'vue'
    export default {
      name: 'PIManage',
      mixins:[JeecgListMixin, mixinDevice],
      components: {
        Labeltemplate
      },
      props:{
        specificationId: {
          type: [String, Number], 
        }
      },
      data () {
        return {
          title: "打印模版列表",
          visible: false,
          disableMixinCreated: true,
          organLabel: '',
          supplierList: [],
          queryParam: {
            organId: "",
            number: "",
            materialParam: "",
            type: "",
            subType: "",
            status: ""
          },
          selectedValueFromChild: [],
          printId: null,
          labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
          },
          url: {
            list: ""
          }
        }
      },
      created() {
      },
      methods: {
        show() {
            this.visible = true
        },
        close () {
          this.$emit('close');
          this.visible = false;
        },
        handleCancel () {
          this.close()
        },
        handleSelectionChange(selectedValue) {
            // 接收子组件传递的选中的值
            this.selectedValueFromChild = selectedValue;
            
            this.printId = selectedValue[0]
            console.log('接收到的选中值:', selectedValue);
        },
        // 绑定模版
        async handleOk(){
            console.log(this.selectedRowKeys,'selectedRowKeys打印模版====================')
            const params = {
                specificationId: this.specificationId,
                templateId: this.printId
            }
            const res = await bindPrintTemplate(params)
            console.log(res,'绑定模版====================')
            if( res.code === 200 && res.success === true ){
                this.$message.success('绑定成功')
                this.visible = false
                this.$emit('getModule', res.result)
            } else {
                this.$message.error(res.message)
            }
        }
      }
    }
  </script>
  
  <style scoped>
   
  </style>